import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
/**
 * Unsuspend Org Member Request Schema
 * POST /api/v2/org-members/:id/unsuspend
 *
 * No request body needed - user ID comes from URL params
 */ export const UnsuspendOrgMemberRequestSchema = z.object({});
/**
 * Unsuspend Org Member Response Schema
 * POST /api/v2/org-members/:id/unsuspend
 */ export const UnsuspendOrgMemberResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=unsuspend-org-member.schema.js.map